import { render, staticRenderFns } from "./journeyInformation.vue?vue&type=template&id=d365c746&"
import script from "./journeyInformation.vue?vue&type=script&lang=js&"
export * from "./journeyInformation.vue?vue&type=script&lang=js&"
import style0 from "./journeyInformation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports